import httpRequest from '_utils/http';

import { TChatConfigFetchResponse } from '_modules/chat/types/service';

export const fetchChatConfig = () =>
  httpRequest.get<TChatConfigFetchResponse>('chat/config');
